export const XP_BASE = 100;
export const XP_MULTIPLICADOR = 1.5;

export function calcularNivel(xpTotal: number): number {
  if (!xpTotal || xpTotal < 0) return 1;
  const nivelReal = Math.pow(xpTotal / XP_BASE, 1 / XP_MULTIPLICADOR);
  return Math.floor(nivelReal) + 1;
}

export function xpParaProximoNivel(xpAtual: number): number {
  const nivelAtualZeroBased = calcularNivel(xpAtual) - 1;
  const xpInicioProximoNivel = XP_BASE * Math.pow(nivelAtualZeroBased + 1, XP_MULTIPLICADOR);
  return Math.max(0, Math.ceil(xpInicioProximoNivel - xpAtual));
}

export function calcularProgressoNivel(xpTotal: number): number {
  if (!xpTotal || xpTotal < 0) return 0;

  const nivelAtual = calcularNivel(xpTotal);
  const nivelAtualZeroBased = nivelAtual - 1;

  const xpInicioNivelAtual = XP_BASE * Math.pow(nivelAtualZeroBased, XP_MULTIPLICADOR);
  const xpInicioProximoNivel = XP_BASE * Math.pow(nivelAtualZeroBased + 1, XP_MULTIPLICADOR);

  const xpDentroNivel = xpTotal - xpInicioNivelAtual;
  const totalXpNivel = xpInicioProximoNivel - xpInicioNivelAtual;

  const progresso = totalXpNivel > 0 ? (xpDentroNivel / totalXpNivel) * 100 : 0;

  return Math.max(0, Math.min(100, progresso));
} 